<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.control" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">№ п.п</td>
          <td rowspan="2">Номер сварного соединения по чертежам (исполнительным чертежам)</td>
          <td rowspan="2">Характеристика стыка, мм, Д х S, марка стали или композиция марок сталей, ГОСТ, ТУ, № сертификата</td>
          <td colspan="4">Сварочные материалы (тип, марка, ГОСТ или ТУ, номер сертификата)</td>
          <td rowspan="2">Номер журнала проверки качества сварочных материалов, регистрационные номера проверок</td>
          <td rowspan="2">Подпись контролера о приемке стыка под сварку</td>
          <td rowspan="2">Положение стыка (поворотное, неповоротное, вертикальное, горизонтальное) </td>
          <td rowspan="2">Дата сварки</td>
          <td rowspan="2">Способ сварки (прихватки, корень шва, заполнение разделки) </td>
          <td rowspan="2">Температура воздуха в рабочей зоне, С</td>
          <td rowspan="2">Температура предварительного, сопутствующего подогрева стыка, С</td>
          <td rowspan="2">Фамилия, Имя, Отчество сварщика, номер клейма</td>
          <td rowspan="2">Подпись сварщика</td>
          <td rowspan="2">Дата термической обработки сварного соединения, номер журнала термической обработки и регистрационный номер в журнале</td>
          <td rowspan="2">Результаты внешнего осмотра и измерений, цветной или магнитной, порошковой дефектоскопии, номер протокола и дата</td>
          <td rowspan="2">Способ контроля качества сварки (радиографическая, ультразвуковая дефектоскопия)</td>
          <td rowspan="2">Дата проведения радиографического контроля или ультразвуковой дефектоскопии, номер заключения, номер журнала контроля</td>
          <td rowspan="2">Результаты замера содержания ферритной фазы в наплавленном металле, номер протокола и дата</td>
          <td rowspan="2">Результаты замера содержания основных: легирующих элементов или стилоскопирования, номер протокола и дата</td>
          <td rowspan="2">Отметки об устраненных дефектах</td>
          <td rowspan="2">Фамилия, Имя, Отчество, номер удостоверения и подпись контроллера</td>
          <td rowspan="2">Фамилия, Имя, Отчество прораба или мастера по сварке, подпись, дата</td>
          <td></td>
        </tr>
        <tr class="header">
          <td>Электроды</td>
          <td>Проволоки</td>
          <td>флюс</td>
          <td>Защитный газ</td>
          <td></td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
          <td>21</td>
          <td>22</td>
          <td>23</td>
          <td>24</td>
          <td>25</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }}
      </template>
      <template #controlSign="{item}">
        <c-journal-sign :sign="getSign(item, 'control')" />
      </template>
      <template #masterEndSign="{item}">
        <c-journal-sign :sign="getSign(item, 'end.master')" />
      </template>
      <template #controlEndSign="{item}">
        <c-journal-sign :sign="getSign(item, 'end.control')" />
      </template>
      <template #welderSign="{item}">
        <c-journal-sign :sign="getSign(item, 'welder')" />
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { CJournalSign, ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        control: $app.auth.can('journals_'+this.journal.name+'_control', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'number', title: '', },
        { name: 'weldingNum', title: '', },
        { name: 'charsWelding', title: '', },
        { name: 'electrod', title: '', },
        { name: 'provolka', title: '', },
        { name: 'flus', title: '', },
        { name: 'guardingGas', title: '', },
        { name: 'journalNum', title: '', },
        { name: 'controlSign', title: '', },
        { name: 'weldPlace', title: '', },
        { name: 'weldingDate', title: '', },
        { name: 'weldingWay', title: '', },
        { name: 'tempInside', title: '', },
        { name: 'tempHeating', title: '', },
        { name: 'welder', title: '', },
        { name: 'welderSign', title: '', },
        { name: 'dateTermDoing', title: '', },
        { name: 'resultOut', title: '', },
        { name: 'controlWay', title: '', },
        { name: 'dateRadio', title: '', },
        { name: 'resultFerrit', title: '', },
        { name: 'resultContain', title: '', },
        { name: 'problemSolve', title: '', },
        { name: 'controlEndSign', title: '', },
        { name: 'masterEndSign', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load() 
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name)
        .query({
          'with[records][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
